import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import SaveIcon from '@material-ui/icons/Save';
import TextField from '@material-ui/core/TextField';
import { DialogTitle } from '@material-ui/core';

const MapValueAttributes = ({
  classes,
  open,
  attributes,
  handleClose,
  onChangeAttribute,
  handleAddAttribute,
  handleEditAttribute,
  handleUpdateMapValue,
  handleCreateAttribute,
  handleDeleteAttribute,
}) => (
  <>
    <Dialog
      open={open}
      maxWidth="xl"
      onClose={handleClose}
      aria-labelledby="title"
      aria-describedby="description"
    >
      <DialogTitle>
        <h3>
          Atributos Mapa de Valor
        </h3>
      </DialogTitle>
      <DialogContent>
        {attributes.map((row, index) => (
          <div key={index}>
            <TextField
              label="Atributo"
              className={classes.textField}
              value={row?.atributo || ''}
              onChange={(e) => onChangeAttribute('atributo', index, e.target.value)}
              style={{ width: '60%' }}
              margin="dense"
              id="outlined-basic"
              variant="outlined"
            />
            <TextField
              label="Peso"
              className={classes.textField}
              value={row?.peso}
              onChange={(e) => onChangeAttribute('peso', index, e.target.value)}
              style={{ width: '12%' }}
              margin="dense"
              id="outlined-basic"
              variant="outlined"
            />
            <IconButton aria-label="add" onClick={handleAddAttribute}>
              <AddIcon />
            </IconButton>

            {!row?.id * 2 || 0 ? (
              <>
                <IconButton
                  aria-label="delete"
                  onClick={() => handleCreateAttribute(index)}
                >
                  <SaveIcon />
                </IconButton>
              </>
            ) : (
              <>
                <IconButton
                  aria-label="delete"
                  onClick={() => handleEditAttribute(index)}
                >
                  <SaveIcon />
                </IconButton>
              </>
            )}

            <IconButton
              aria-label="delete"
              onClick={() => handleDeleteAttribute(index)}
            >
              <DeleteIcon />
            </IconButton>
          </div>
        ))}
      </DialogContent>
      <DialogActions id="buttons-print">
        <Button onClick={() => handleUpdateMapValue(true)} color="github">
          Guardar
        </Button>
        <Button onClick={handleClose} color="github" autoFocus>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  </>
);

export default MapValueAttributes;
